import { useDispatch, useSelector } from 'react-redux';
import { updateProfile, getProfile } from '../../../redux/profile/action';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CloudStorage from '../../../CloudStorage/CloudStorage';
import TimePickerRSuite from '../../Common/TimePickerRSuite';
import { useEffect, useState } from 'react'; // Add useState import

export default function WorkingHours({ profile }) {
  const dispatch = useDispatch();
  const [refreshKey, setRefreshKey] = useState(0); // Add refresh key state

  useEffect(() => {
    refreshProfileData();
  }, []);

  const refreshProfileData = () => {
    dispatch(getProfile());
  };

  const timeToMinutes = (time) => {
    const [hour, minutes] = time.split(':').map(Number);
    return hour * 60 + minutes;
  };

  const formik = useFormik({
    initialValues: {
      workingHours: [{ start_time: '', end_time: '' }],
    },
    validationSchema: Yup.object({
      workingHours: Yup.array().of(
        Yup.object({
          start_time: Yup.string()
            .required('Start time is required')
            .matches(/^([0-9]{2}):([0-9]{2})$/, 'Invalid time format'),
          end_time: Yup.string()
            .required('End time is required')
            .matches(/^([0-9]{2}):([0-9]{2})$/, 'Invalid time format')
            .test('is-end-time-greater', 'End time must be greater than start time', function (value) {
              const { start_time } = this.parent;
              if (!start_time || !value) return true;
              return timeToMinutes(value) > timeToMinutes(start_time);
            }),
        })
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      const data = {
        type: 'working_hours',
        working_hours: {
          start_time: values.workingHours[0].start_time,
          end_time: values.workingHours[0].end_time,
        },
      };

      try {
        await dispatch(updateProfile(data));
        refreshProfileData();
        
        // Reset form and trigger refresh
        resetForm();
        setRefreshKey(prev => prev + 1); // Increment key to force re-render
        
      } catch (error) {
        console.error('Failed to update working hours:', error);
      }
    },
  });

  const formatTimeTo12hr = (time) => {
    const [hour, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hour, minutes);

    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return new Intl.DateTimeFormat('en-US', options).format(date).toLowerCase();
  };

  const removehourstime = async (id) => {
    const data = {
      type: 'delete_working_hours',
      working_hours: {
        id: id,
      },
    };

    try {
      await dispatch(updateProfile(data));
      refreshProfileData();
    } catch (error) {
      console.error('Failed to delete working hours:', error);
    }
  };

  return (
    <>
      <div>
        <h5 className="mb-0">Working Hour</h5>
        <p>Select your working hour</p>
        {Array.isArray(profile?.working_hours) &&
          profile?.working_hours?.map((item, index) => (
            <div className="row" style={{ marginTop: 20 }} key={index}>
              <div className="col-md-4 col-10 form-group mb-0">
                <input
                  type="text"
                  className="form-control"
                  value={`${formatTimeTo12hr(item.start_time)} - ${formatTimeTo12hr(item.end_time)}`}
                  readOnly
                />
              </div>
              <div className="col-md-2 col-2 form-group mb-0">
                <button
                  onClick={() => removehourstime(item?.id)}
                  style={{ border: '0', padding: '0', background: 'transparent' }}
                  type="button"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`}
                    alt="Delete"
                  />
                </button>
              </div>
            </div>
          ))}
      </div>
      
      {/* Add key prop to force re-render of this section */}
      <span className='refesh-this-tab-on-submit-api-show-can-clear-data' key={refreshKey}>
        <div className="col-md-11 p-0" style={{ marginTop: 30 }}>
          <form onSubmit={formik.handleSubmit}>
            {formik.values.workingHours.map((slot, index) => (
              <div className="row" key={index}>
                <div className="col-md-4 form-group mb-0">
                  <label>From</label>
                  <TimePickerRSuite
                    formik={formik}
                    name={`workingHours[${index}].start_time`}
                    label="From"
                  />
                  {formik.touched.workingHours?.[index]?.start_time && formik.errors.workingHours?.[index]?.start_time && (
                    <div className="text-danger mt-4">{formik.errors.workingHours[index].start_time}</div>
                  )}
                </div>
                <div className="col-md-4 form-group mb-0">
                  <label>To</label>
                  <TimePickerRSuite
                    formik={formik}
                    name={`workingHours[${index}].end_time`}
                    label="To"
                  />
                  {formik.touched.workingHours?.[index]?.end_time && formik.errors.workingHours?.[index]?.end_time && (
                    <div className="text-danger mt-4">{formik.errors.workingHours[index].end_time}</div>
                  )}
                </div>
                <div className="col-md-4 form-group mb-0">
                  <label>&nbsp;</label>
                  <button
                    type="submit"
                    className="buttons background-button"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? 'Adding...' : 'Add Time'}
                  </button>
                </div>
              </div>
            ))}
          </form>
        </div>
      </span>
    </>
  );
}